import { render, staticRenderFns } from "./OffersDisplay.vue?vue&type=template&id=22ffd481&scoped=true"
import script from "./OffersDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./OffersDisplay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OffersDisplay.vue?vue&type=style&index=0&id=22ffd481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ffd481",
  null
  
)

export default component.exports